import React from "react";
import CrudPage from "@/components/CrudPage";
import { AnniOreField, totOre } from "@/components/AnniOreField";
import { fmtEuro, fmtDate } from "@/lib/constants";

const annoCorrente = (r) => (r.anni || []).find((a) => a.anno === r.anno);

export default function Personale() {
  return (
    <CrudPage
      title="Personale INDAR"
      subtitle="Risorse interne, costo orario per anno e ore lavorate mensili"
      endpoint="personale"
      testid="personale-page"
      validate={(f) => (f.dal && f.cessato_il && f.cessato_il < f.dal ? "La data di cessazione è precedente alla data di assunzione." : "")}
      allegati
      wide
      columns={[
        { key: "nome", label: "Nominativo", render: (r) => <span className="font-medium text-slate-900">{r.cognome} {r.nome}</span> },
        { key: "ruolo", label: "Ruolo" },
        { key: "dal", label: "Assunto il", render: (r) => fmtDate(r.dal) },
        { key: "cessato_il", label: "Cessato il", render: (r) => (r.cessato_il ? <span className="text-rose-600">{fmtDate(r.cessato_il)}</span> : "—") },
        { key: "costo_orario", label: "Costo/h", render: (r) => (r.costo_orario != null ? <span>{fmtEuro(r.costo_orario)}{r.anno ? <span className="ml-1 text-xs text-slate-400">({r.anno})</span> : null}</span> : "—") },
        { key: "ore_anno", label: "Ore lavorate anno", render: (r) => { const a = annoCorrente(r); return a ? `${totOre(a)}h` : "—"; } },
      ]}
      fields={[
        { name: "nome", label: "Nome", type: "text" },
        { name: "cognome", label: "Cognome", type: "text" },
        { name: "cf", label: "Codice Fiscale", type: "text" },
        { name: "ruolo", label: "Ruolo", type: "text" },
        { name: "email", label: "Email aziendale", type: "text" },
        { name: "telefono_azienda", label: "Recapito telefonico in azienda", type: "text" },
        { name: "dal", label: "Assunto in data", type: "date" },
        { name: "cessato_il", label: "Cessato in data", type: "date" },
        { name: "ore_mensili", label: "Ore lavorabili mese", type: "number" },
        { name: "ore_imputate", label: "Ore imputate (corsi)", type: "number" },
        { name: "mese_riferimento", label: "Mese riferimento (YYYY-MM)", type: "text" },
        { type: "heading", label: "Costo orario e ore lavorate per anno", name: "h_anni" },
        { name: "anni", label: "", type: "custom", component: AnniOreField, full: true, default: [] },
        { name: "note", label: "Note", type: "textarea", full: true },
      ]}
    />
  );
}
